import * as camelcaseKeys from 'camelcase-keys';
import { MonoTypeOperatorFunction } from 'rxjs';
import { map } from 'rxjs/operators';
import { default as snakecaseKeys } from 'snakecase-keys';

export const toCamelcase = <T>(): MonoTypeOperatorFunction<T> => map((obj) => camelcaseKeys(obj, { deep: true }) as T);
export const toSnakecase = <T>(): MonoTypeOperatorFunction<T> => map((obj) => snakecaseKeys(obj as any, { deep: true }) as T);
export const toCamelcaseFun = <T>(obj: T): T => camelcaseKeys(obj, { deep: true }) as T;
export const toSnakecaseFun = <T>(obj: T): T => snakecaseKeys(obj as any, { deep: true }) as T;
